var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAppleLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.984 9.54457C12.0082 12.2634 14.2649 13.1682 14.2898 13.1797C14.2707 13.2435 13.9293 14.469 13.101 15.7349C12.3849 16.8294 11.6417 17.9198 10.4709 17.9423C9.32069 17.9645 8.95076 17.229 7.63559 17.229C6.3208 17.229 5.90982 17.9198 4.82088 17.9645C3.69084 18.0093 2.83031 16.7811 2.10836 15.6906C0.632971 13.4602 -0.494497 9.38777 1.01941 6.63886C1.77148 5.27371 3.11555 4.40931 4.57433 4.38714C5.68398 4.36503 6.73139 5.16783 7.40974 5.16783C8.08765 5.16783 9.36048 4.2024 10.6985 4.34417C11.2586 4.36857 12.8311 4.58074 13.8407 6.12623C13.7593 6.17897 11.9645 7.2716 11.984 9.54463M9.82216 2.86851C10.4222 2.10909 10.8259 1.05194 10.7158 0C9.85096 0.0363429 8.80529 0.602629 8.18498 1.3616C7.62908 2.03377 7.14226 3.10954 7.27362 4.14063C8.23754 4.21863 9.22217 3.6284 9.82216 2.86851Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9902,
    height: 18,
    fill: "white",
    transform: "translate(0.300293)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppleLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AppleLogo.81a54e94.svg";
export { ForwardRef as ReactComponent };